import { render } from "./TextStyles.vue?vue&type=template&id=f9babc40&scoped=true&ts=true"
import script from "./TextStyles.vue?vue&type=script&lang=ts"
export * from "./TextStyles.vue?vue&type=script&lang=ts"

import "./TextStyles.vue?vue&type=style&index=0&id=f9babc40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9babc40"]])

export default __exports__